import type { FC } from "react";

import { isEditing } from "@builder.io/sdk-react";

import { ReferralPersonalCode as UIReferralPersonalCode } from "@jti/loyalty/components/ReferralPersonalCode";
import { buildShareConfig } from "@jti/ui/utils/share";

import type { referralPersonalCodeInputs } from "./ReferralPersonalCode.builder";

type ReferralPersonalCodeBuilderProps = BuilderComponentProps<typeof referralPersonalCodeInputs>;

export const ReferralPersonalCode: FC<ReferralPersonalCodeBuilderProps> = (props) => {
  const shareConfig = buildShareConfig(props.shareConfig);

  const referralPersonalCodeProps = {
    ...props,
    items: props.items ?? [],
    signInUrl: props.signInUrl ?? "",
    signInTitle: props.signInTitle ?? "",
    registerUrl: props.registerUrl ?? "",
    registerTitle: props.registerTitle ?? "",
    shareConfig,
  };

  return <UIReferralPersonalCode {...referralPersonalCodeProps} isInEditor={isEditing()} isInBuilder />;
};
